'use strict';/* global define:false */define('helen/filters/from',[],function(){'use strict';function filter(){return function(collection,index){return collection.slice(index);};}return filter;});
